import { Selection } from "d3";
import { DataDRequest } from "../../../data/DRequest";
import { Entidad } from "../../../data/Entidad";
import { _SvAgregarAgendaTarea, _SvEditarAgendaTarea, _SvEliminarAgendaTarea, _SvGrupoObtenerEventosCalendarios, _SvGrupoObtenerMaestrosAgendaTareas, _SvGruposObtenerMaestros } from "../../../data/modulo/Grupo";
import { DataModuloMain } from "../../../data/ModuloMain";
import _L from "../../../util/Labels";
import { TCARDV2COLL_OnEditOriginEvent } from "../../controlD3/CardV2/CardV2Collapse";
import { CardV2CollapseAdvancedTable, IConfigCardV2CollapseExcelExport } from "../../controlD3/CardV2/CardV2CollapseAdvancedTable";
import { SelectV2 } from "../../controlD3/SelectV2";
import { Table } from "../../controlD3/Tabla";
import { UIUtilTime } from "../../util/Time";
import { UIUtilGeneral } from "../../util/Util";
import { UIUtilViewData } from "../../util/ViewData";
import { IMaestroAsignado } from "./GruposMaestrosV2";


import { _DICC_ESCUELA } from "../../../data/modulo/Escuela";
import { Router } from "../../../routes/Router";
import { DateV2 } from "../../../util/DateV2";
import { ElementWrapper } from "../../controlD3/ElementWrapper";
import { _ModalConfirmacionBasicoV2 } from "../../controlD3/ModalThings/ModalConfirmacionBasicoV2";
import { UIUtilIconResources } from "../../util/IconResourses";
import { UIUtilPermission } from "../../util/Permission";
import { AgendaTaskActionForm } from "../../utilView/GrupoPanel/GrupoAgenda";

import { MCicloEscolar } from "../../../data/model/MCicloEscolar";
import { _DICC_CICLO_ESCOLAR } from "../../../data/modulo/CicloEscolar";
import { MGrupo } from "../../../data/model/MGrupo";
import { IMonthPeriod } from "../../../data/entidad/CicloEscolar";
export enum CAgendaEventType {
    Kinder = 1,
    Grupo = 2,
    Maestro = 3,
}

export interface IAgendaEvent {
    Id: number;
    IdGrid: string;
    IdOrigin: number;
    Name: string;
    OriginType: CAgendaEventType;
    StrOriginType: string;
    OriginName: string;
    StrStart: string;
    StrEnd: string;
    StrType: string;
}

interface IPeriodoD extends IMonthPeriod {
    EnCicloEscolar: boolean;
}

export class UIPanelCardGruposAgenda extends CardV2CollapseAdvancedTable<IAgendaEvent, [MGrupo]> {
    private ctrlSelectCicloEscolar: SelectV2<MCicloEscolar, "Id", "monoselect">;
    private ctrlSelectPeriodo: SelectV2<IPeriodoD, "Id", "monoselect">;
    private areaMenuSelects: Selection<HTMLDivElement, any, any, any>;
    private agendaTasksMap: Map<string, IAgendaEvent[]>;
    private agendaCalendarEventsMap: Map<string, IAgendaEvent[]>;

    constructor(module: Entidad.CModulo) {
        super("", module);
        this.agendaTasksMap = new Map<string, IAgendaEvent[]>();
        this.agendaCalendarEventsMap = new Map<string, IAgendaEvent[]>();
    }

    protected CARDCOLLADTAB_Table_GetMenuTop(): Array<Table.ITableMenuTopDefaultOptionConfig> {
        const topOptions: Array<Table.ITableMenuTopDefaultOptionConfig> = [];

        if (this.HasActionPermission(Entidad.CAccionPermiso.Agregar)) {
            topOptions.push({
                Callback: () => {
                    this.OpenModalAgregarTareaAgenda();
                },
                Label: "Agregar actividad",
            })

            topOptions.push({
                Callback: () => {
                    this.ConfirmActionGoToCalendars(<IAgendaEvent>{ IdOrigin: this.GetCurrentGroup().IdGrupo }, Entidad.CAccionPermiso.Agregar);
                },
                Label: "Agregar evento de calendario",
            })
        }

        return topOptions;
    }
    protected CARDCOLLADTAB_GetExportarConfig(dataTable: IAgendaEvent[]): IConfigCardV2CollapseExcelExport<IAgendaEvent | any> | Promise<IConfigCardV2CollapseExcelExport<IAgendaEvent | any>> {
        const grupo = this.cardData[0];
        return {
            FileName: `${grupo.Nombre} - ${_L("grupopanelagenda.card_headertitle")}`,
            IdsEscuelas: [grupo.IdKinder],
            TypeRequest: Entidad.CTipoRequest.Grupo,
            ColumnsConfig: this.ctrlTabla._InfoColumns.filter(d => d.Field != "OriginType")
                .map(d => ({
                    Field: d.Field as keyof IAgendaEvent,
                    HeaderTag: d.Label,
                    WidthCell: 25,
                })),
            OnGetDataBySheets: async () => {
                return [{
                    IdSheet: grupo.IdKinder,
                    SheetName: grupo.Nombre,
                    Data: dataTable,
                }]
            },
            OnGetEscuelasTagInSheet: () => _DICC_ESCUELA.get(grupo.IdKinder).Nombre,
            OnStepFieldInDataRow: (field: keyof IAgendaEvent, dato: IAgendaEvent) => {
                if ((field == "StrStart" || field == "StrEnd") && dato[field]) {
                    return dato[field] ? UIUtilTime._DateFormatStandar(dato[field], "dd/mm/yyyy h12:mm") : "---"
                }
                return dato[field] as string;
            },
        }
    }
    protected CARDCOLLADTAB_Table_GetConfig(): Omit<Table.IConfig<IAgendaEvent>, "Parent"> {
        return {
            IdTabla: "GruposPanelAgenda",
            LangModuleKeyInContext: "grupopanelagenda",
            Title: "",
            IdData: "IdGrid",
            MinWidth: 600,
            StickyCheckInRow: true,
            RenderColumnHeadings: [
                { Field: "OriginType", Label: "", Width: "4%", MinWidth: "26px", IsSortable: false },
                { Field: "StrType", Label: "", Width: "19%", MinWidth: "60px" },
                { Field: "Name", Label: "", Width: "19%", MinWidth: "75px" },
                { Field: "StrOriginType", Label: "", Width: "19%", MinWidth: "75px" },
                { Field: "StrStart", Label: "", Width: "19%", MinWidth: "75px" },
                { Field: "StrEnd", Label: "", Width: "19%", MinWidth: "75px" }
            ],
            OrderDefault: { Field: "StrStart", Type: Table.CStatusOrder.Asc },
            OptionsOfActiveSelectedDataV3: (data) => {
                if (data.length) {
                    let datosAcciones = this.UI_TableGetSelectedDataMenuLvlOne("top-selected", data)
                    return this.CARDCOLLADTAB_GetTableOptionsToSelectedData(this.cardData[0].IdKinder, "top-selected", datosAcciones);
                }
            },
            EvaluatorAndSubLevelsBuild: {
                OnStepCellTable: (container, datum, fieldName: keyof IAgendaEvent) => {
                    switch (fieldName) {
                        case "OriginType":
                            const isActivity = ![CAgendaEventType.Kinder, CAgendaEventType.Grupo].includes(datum.OriginType);
                            container.text("");
                            container.append("img")
                                .attr(
                                    "src",
                                    !isActivity
                                        ? UIUtilIconResources.CGeneral.CalendarEvent
                                        : UIUtilIconResources.CActividadesEscolaridad.Actividades
                                )
                                .style("width", "20px")
                            break
                        case "StrStart":
                            container.text(datum.StrStart ? UIUtilTime._DateFormatStandar(datum.StrStart, "dd/mm/yyyy h12:mm") : "---");
                            break;
                        case "StrEnd":
                            container.text(datum.StrEnd ? UIUtilTime._DateFormatStandar(datum.StrEnd, "dd/mm/yyyy h12:mm") : "---");
                            break;
                    }
                },
                GetOptionsInRowV2: (dato) => this.CARDCOLLADTAB_GetTableOptionsToSelectedData(this.GetCurrentGroup().IdKinder, "row", this.UI_TableGetSelectedDataMenuLvlOne("row", [dato])),
            },
            FilterParameters: [
                { LabelLangKey: "d_field_name", Field: "Name" },
                {
                    LabelLangKey: "d_field_strorigintype", Field: "OriginName", Type: "select", Options: [
                        { Id: CAgendaEventType.Kinder, Name: _L("grupopanelagenda.lbl_allschool") },
                        { Id: CAgendaEventType.Grupo, Name: _L("grupopanelagenda.lbl_allgroup") },
                        { Id: CAgendaEventType.Maestro, Name: _L("grupopanelagenda.lbl_teacher") }
                    ],
                    OnGetValueToMatch: (dato) => {
                        return [dato.OriginType];
                    },
                },
                { LabelLangKey: "d_field_strstart", Field: "StrStart", Type: "date" },
                { LabelLangKey: "d_field_strend", Field: "StrEnd", Type: "date" }
            ]
        }
    }
    protected CARDCOLL_OnInitBuild(contentContainer: TSelectionHTML<"div">): void {
        this.btnEditarCard._d3Selection.remove();
        this.cardFooterSelection.remove();

        contentContainer
            .classed("card_grupo_materia", true)
            .classed(UIUtilGeneral.FBoxOrientation.Horizontal, true);

        this.areaMenuSelects = contentContainer.append("div")
            .classed("area_filtros", true);

        this.ctrlSelectCicloEscolar = new SelectV2<MCicloEscolar, "Id">({
            Parent: this.areaMenuSelects,
            Type: "monoselect",
            DisplayMember: "Nombre",
            ValueMember: "Id",
            Data: () => this.GetCiclosEscolaresList(),
            OnChange: (_, cicloEsc) => {
                let periods = this.GetPeriodsListFromCicloEscolar(cicloEsc);
                const periodoCurrent = this.GetCurrentPeriodFromCicloEsc(periods);
                this.ctrlSelectPeriodo._UpdateList(periods);
                this.ctrlSelectPeriodo._valueSelect(periodoCurrent.Id);
                this.UI_UpdateCardData(true);
            }
        })

        this.areaMenuSelects.append(() => ElementWrapper._WrapperToSelectControl(this.ctrlSelectCicloEscolar, _L("grupopanelagenda.filtro_cicloesc")).node());

        this.ctrlSelectPeriodo = new SelectV2<IPeriodoD, "Id">({
            Parent: this.areaMenuSelects,
            Type: "monoselect",
            Data: () => this.GetPeriodsListFromCicloEscolar(this.ctrlSelectCicloEscolar._dataSelected[0]),
            ValueMember: "Id",
            DisplayMember: "Name",
            OnChange: () => {
                this.UI_UpdateCardData(true);
            },
        })

        this.areaMenuSelects.append(() => ElementWrapper._WrapperToSelectControl(this.ctrlSelectPeriodo, _L("grupopanelagenda.filtro_period")).node());
        return;
    }
    protected CARDCOLL_GetVariantToValidateUpdate(cardData_0: MGrupo): string {
        return cardData_0.IdGrupo + cardData_0.Nombre + cardData_0.EsPrincipal + cardData_0.IdNivel + cardData_0.IdEscolaridad;
    }
    protected CARDCOLL_OnUpdateData(cardData_0: MGrupo): void | Promise<void> {
        this.UI_UpdateCardData(true);
    }
    protected CARDCOLL_MostrarBody(): void {
        this.UI_UpdateCardData(true);
    }
    protected CARDCOLL_OcultarBody(): void {
        return;
    }
    protected CARDCOLL_OnEditarCard(originEvent: TCARDV2COLL_OnEditOriginEvent): void {
    }
    protected CARDCOLL_OnCancelaEditarCard(originEvent: TCARDV2COLL_OnEditOriginEvent): void {
    }
    protected CARDCOLL_GuardarCardV2(): Promise<DataDRequest.IRequestResponseA<any>> {
        return null;
    }
    protected CARDCOLL_SyncOrGetIdToDownloadData(): (() => Promise<any>) | (DataModuloMain.TipoRequestMonitorId | DataModuloMain.TipoRequestMonitorId[]) {
        return () => this.UI_UpdateCardData(true);
    }
    protected CARDCOLL_GetIdSchool(cardData_0_0: MGrupo): number {
        return cardData_0_0.IdKinder;
    }

    private async UI_UpdateCardData(showProgressBar = false) {
        let currentGroup = this.GetCurrentGroup();
        if (!this.CARDCOLL_StatusCardExpandido || !currentGroup) {
            this.ctrlTabla._UpdateData([]);
            return null;
        }

        this.ctrlSelectCicloEscolar._RefreshList();
        const cicloEscolaresList = this.ctrlSelectCicloEscolar._dataitems;
        let cicloEscCurrent: MCicloEscolar;
        if (!this.ctrlSelectCicloEscolar._dataValueMemberSelected.length) {
            cicloEscCurrent = this.GetCurrentCicloEscolar(cicloEscolaresList);
            this.ctrlSelectCicloEscolar._valueSelect(cicloEscCurrent?.Id);
        }

        this.ctrlSelectPeriodo._RefreshList();
        const periodosList = this.ctrlSelectPeriodo._dataitems;
        if (!this.ctrlSelectPeriodo._dataValueMemberSelected.length) {
            const periodoCurrent = this.GetCurrentPeriodFromCicloEsc(periodosList);
            this.ctrlSelectPeriodo._valueSelect(periodoCurrent?.Id);
        }


        const [cicloEsc] = this.ctrlSelectCicloEscolar._dataSelected || [];
        const [period] = this.ctrlSelectPeriodo._dataSelected || [];
        if (!cicloEsc || !period) return [];
        if (showProgressBar) {
            this.ctrlProgress.attr("oculto", false);
        }

        await this.Sv_GetAgendaEventsList(cicloEsc, period);

        if (showProgressBar) {
            this.ctrlProgress.attr("oculto", true);
        }
    }
    private UI_TableGetSelectedDataMenuLvlOne(location: "row" | "top-selected", agendaEvent: IAgendaEvent[]) {
        let opciones: Table.ITableMenuDataSelectedOptionConfig<IAgendaEvent>[] = [];

        if (this.HasActionPermission(Entidad.CAccionPermiso.Editar)) {
            opciones.push({
                Label: _L("c_actions.editar"),
                Callback: (data) => {
                    const [event] = data
                    switch (event.OriginType) {
                        case CAgendaEventType.Maestro:
                            this.OpenModal_EditarTareaAgenda(event);
                            break;
                        case CAgendaEventType.Grupo:
                        case CAgendaEventType.Kinder:
                            this.ConfirmActionGoToCalendars(event, Entidad.CAccionPermiso.Editar);
                            break;
                    }
                },
                MultiData: false,
            })
        }

        if (this.HasActionPermission(Entidad.CAccionPermiso.Eliminar)) {
            opciones.push({
                Label: _L("c_actions.eliminar"),
                Callback: (data) => {
                    const [event] = data
                    switch (event.OriginType) {
                        case CAgendaEventType.Maestro:
                            this.OpenModalEliminarTareaAgenda(data);
                            break;
                        case CAgendaEventType.Grupo:
                        case CAgendaEventType.Kinder:
                            this.ConfirmActionGoToCalendars(event, Entidad.CAccionPermiso.Eliminar);
                            break;
                    }
                },
                MultiData: !agendaEvent.some(d => d.OriginType != CAgendaEventType.Maestro),
                GetDetails: (data) => {
                    const allSameOriginType = data.every(ev => ev.OriginType === data[0].OriginType);
                    return {
                        Enabled: allSameOriginType,
                        Description: allSameOriginType ? "" : _L("grupopanelagenda.tlt_deletefail_nosametype")
                    }
                },
            })
        }

        return opciones;
    }

    private GetCurrentGroup() {
        if (this.cardData) {
            return this.cardData[0] || null;
        }
        return null;
    }

    private GetIdEscuela() {
        return this.GetCurrentGroup()?.IdKinder || null;
    }

    private GetCiclosEscolaresList() {
        const nowTime = new Date().getTime();

        return Array.from(_DICC_CICLO_ESCOLAR.values())
            .filter(d =>
                d.IdEscuela == this.GetIdEscuela()
                && (new Date(d.FechaFin).getTime() >= nowTime)
            )
            .sort((a, b) => new Date(a.FechaInicio).getTime() - new Date(b.FechaInicio).getTime());
    }

    private GetCurrentCicloEscolar(ciclosEscolaresList: MCicloEscolar[]) {
        const idEscuela = this.GetIdEscuela();
        const now = new DateV2()._SetTimeZoneByIdSchool(idEscuela).getTime();

        let cicloEsc = ciclosEscolaresList
            .filter(dCiclo => dCiclo.IdEscuela == idEscuela)
            .find(d => new DateV2(d.FechaInicio)._SetTimeZoneByIdSchool(idEscuela).getTime() <= now && new DateV2(d.FechaFin)._SetTimeZoneByIdSchool(idEscuela).getTime() > now);

        if (!cicloEsc) {
            cicloEsc = ciclosEscolaresList[0];
        }

        return cicloEsc;
    }

    private GetPeriodsListFromCicloEscolar(cicloEsc: MCicloEscolar): IPeriodoD[] {
        let periods: IPeriodoD[] = [];
        if (cicloEsc) {
            periods = cicloEsc._GetPeriodsFromCicloEscolarV2("after", "asc").map(d => ({ ...d, EnCicloEscolar: true }));
        }
        return periods;
    }

    private GetCurrentPeriodFromCicloEsc(periods: IPeriodoD[]) {
        const now = new Date();

        let periodo = periods
            .find(d => d.Month == now.getMonth() && d.Year == now.getFullYear());

        if (!periodo && periods) {
            periodo = periods[0];
        }

        return periodo;
    }

    private GetAgendaTasksList(idGroup?: number) {
        if (!idGroup) {
            idGroup = this.GetCurrentGroup().IdGrupo;
        }

        return (this.agendaTasksMap.get(idGroup.toString()) || []);
    }

    private SetAgendaTasksList(idGroup: number, agendaTasksList: IAgendaEvent[]) {
        this.agendaTasksMap.set(idGroup.toString(), agendaTasksList)
    }

    private GetAgendaCalendarEventsList(idGroup?: number) {
        if (!idGroup) {
            idGroup = this.GetCurrentGroup().IdGrupo;
        }

        return (this.agendaCalendarEventsMap.get(idGroup.toString()) || []);
    }

    private SetAgendaCalendarEventsList(idGroup: number, agendaCalendarEventsList: IAgendaEvent[]) {
        this.agendaCalendarEventsMap.set(idGroup.toString(), agendaCalendarEventsList);
    }

    private async Sv_GetAgendaEventsList(cicloEsc: MCicloEscolar, period: IPeriodoD) {
        const cicloEscStartDateValidator = new Date(cicloEsc.FechaInicio);
        const cicloEscEndDateValidator = new Date(cicloEsc.FechaFin);
        let periodStartDateValidator = new Date(period.Year, period.Month, 1);
        let periodEndDateValidator = new Date(periodStartDateValidator);
        periodEndDateValidator.setMonth(periodEndDateValidator.getMonth() + 1);
        periodEndDateValidator.setMilliseconds(periodEndDateValidator.getMilliseconds() - 1);

        if (periodStartDateValidator.getTime() < cicloEscStartDateValidator.getTime()) {
            periodStartDateValidator = cicloEscStartDateValidator;
        }
        if (periodEndDateValidator.getTime() > cicloEscEndDateValidator.getTime()) {
            periodEndDateValidator = cicloEscEndDateValidator;
        }

        // QUESTION: SOBRE EL AJUSTE DE LOS MILLISECONDS (en este momento en periodos se ajusta al ultimo instante del día con ciclos se toma el primer instante)
        const { list: calendarEventsList, error: errorCalendarRes } = await this.Sv_GetListaEventosCalendario(periodStartDateValidator.toISOString(), periodEndDateValidator.toISOString());
        const { list: teachersTasksList, error: errorTeachersTasksRes } = await this.Sv_GetListaMaestrasAgendaTareas(periodStartDateValidator.toISOString(), periodEndDateValidator.toISOString());

        if (errorCalendarRes || errorTeachersTasksRes) {
            this.ctrlNotification._Mostrar("Error al actualizar la información", "ADVERTENCIA");
        }

        const nowTime = new Date().getTime();

        let eventsMixed = [...calendarEventsList, ...teachersTasksList]
            .filter(ev => new Date(ev.StrStart).getTime() >= nowTime || new Date(ev.StrEnd).getTime() >= nowTime)
            .map(d => {
                switch (d.OriginType) {
                    case CAgendaEventType.Kinder:
                        d.StrOriginType = _L("grupopanelagenda.lbl_allschool");
                        break;
                    case CAgendaEventType.Grupo:
                        d.StrOriginType = _L("grupopanelagenda.lbl_allgroup");
                        break;
                    case CAgendaEventType.Maestro:
                        d.StrOriginType = `${d.OriginName} (${_L("grupopanelagenda.lbl_teacher")})`;
                        break;
                }
                const isActivity = ![CAgendaEventType.Kinder, CAgendaEventType.Grupo].includes(d.OriginType);

                d.StrType = isActivity ? "Actividad" : "Evento de calendario"

                return d;
            });

        this.ctrlTabla._UpdateData(eventsMixed);
    }

    private async Sv_GetListaEventosCalendario(strStartRange: string, strEndRange: string): Promise<{ list: IAgendaEvent[], error: boolean }> {
        const group = this.GetCurrentGroup();
        if (!group) {
            return { list: [], error: false };
        }
        const idGroup = group.IdGrupo;
        const idSchool = group.IdKinder;

        let res = await _SvGrupoObtenerEventosCalendarios(idSchool, idGroup, strStartRange, strEndRange);
        let eventosCalendario = res.Datos as IAgendaEvent[] || [];

        if (res.Resultado > 0) {
            eventosCalendario.forEach(ev => {
                ev.IdGrid = `${ev.Id}_${ev.OriginType}`;
                switch (ev.OriginType) {
                    case CAgendaEventType.Grupo:
                        ev.OriginName = group.Nombre;
                        break;
                    case CAgendaEventType.Kinder:
                        ev.OriginName = group.NombreKinder;
                        break;
                }
            })

            this.SetAgendaCalendarEventsList(idGroup, eventosCalendario);
        }

        return { list: this.GetAgendaCalendarEventsList(idGroup), error: res.Resultado < 1 };
    }

    private async Sv_GetListaMaestrasAgendaTareas(strStartRange: string, strEndRange: string): Promise<{ list: IAgendaEvent[], error: boolean }> {
        const currentGroup = this.GetCurrentGroup();
        if (!currentGroup) {
            return { list: [], error: false };
        }
        const { IdGrupo } = currentGroup;

        let resTeachers = await _SvGruposObtenerMaestros(IdGrupo);
        let maestrosList = (resTeachers.Datos as IMaestroAsignado[] || []);

        if (resTeachers.Resultado < 1) {
            return { list: this.GetAgendaTasksList(IdGrupo), error: true };
        }

        maestrosList.forEach(m => {
            m.NombreCompleto = [m.Nombre, m.ApPaterno, m?.ApMaterno].filter(d => !!d).join(" ");
        })

        if (!maestrosList.length) {
            this.SetAgendaTasksList(IdGrupo, []);
            return { list: this.GetAgendaTasksList(IdGrupo), error: false };
        }

        const teachersIds = maestrosList.map(d => d.IdMaestro);
        let res = await _SvGrupoObtenerMaestrosAgendaTareas(teachersIds, strStartRange, strEndRange);
        let maestrasAgendaTareas = res.Datos || [];

        if (res.Resultado > 0) {
            maestrasAgendaTareas.forEach(tagenda => {
                const teacher = maestrosList.find(m => m.IdMaestro == tagenda.IdMaestra);
                tagenda.OriginType = CAgendaEventType.Maestro;
                tagenda.OriginName = teacher?.NombreCompleto || _L("general.nodisponible");
                tagenda.IdGrid = `${tagenda.Id}_${tagenda.OriginType}`
            })
            this.SetAgendaTasksList(IdGrupo, maestrasAgendaTareas);
        }

        return { list: this.GetAgendaTasksList(IdGrupo), error: res.Resultado < 1 };
    }

    private OpenModal_EditarTareaAgenda(tareaAgenda: IAgendaEvent) {
        this.CARDCOLLAD_OpenModal_ActionFormToAGridData({
            Title: _L("grupopanelagenda.ttl_agendatask_edit"),
            Action: Entidad.CAccionPermiso.Editar,
            IdsEscuelas: [this.GetIdEscuela()],
            GetForm: (content, modalThings) => AgendaTaskActionForm(tareaAgenda, Entidad.CAccionPermiso.Editar, this.GetCurrentGroup().IdGrupo),
            Width: 350,
            OnAccept: async (form, modalThings) => {
                let dataForm = form._Data;
                const { StrStart } = dataForm;
                let dateStart = UIUtilTime._GetLocalDateFromInputDateString(StrStart);
                let dateEnd = new Date(dateStart);
                dateEnd.setDate(dateEnd.getDate() + 1);
                dateEnd.setMilliseconds(dateEnd.getMilliseconds() - 1);

                let res = await _SvEditarAgendaTarea({ ...dataForm, StrStart: dateStart.toISOString(), StrEnd: dateEnd.toISOString() })
                return res;
            },
            TypeRequest: null,
            OnEndReloadService: async (res) => {
                if (res.Resultado > 0 || res.Resultado == -1) {
                    this.UI_UpdateCardData();
                }
            },
        })
    }

    private OpenModalEliminarTareaAgenda(tareasAgenda: IAgendaEvent[]) {
        this.CARDCOLLAD_OpenModal_ProccessArrayData({
            Title: _L("grupopanelagenda.ttl_agendatasks_delete"),
            Message: _L("grupopanelagenda.confirmagendatasks_delete", tareasAgenda.length.toString()),
            Action: Entidad.CAccionPermiso.Eliminar,
            OnGetIdEscuela: () => this.GetIdEscuela(),
            DataToProccess: tareasAgenda,
            OnStepAProccess: (dato) => _SvEliminarAgendaTarea(dato),
            OnEndAndCloseProccess: async (datosCorrectos, datosError, results) => {
                if (datosCorrectos.length || results.some(r => r.Resultado == -1)) {
                    this.UI_UpdateCardData();
                }
            },
            OnError_GetItemDataTag: (itemData, container) => {
                return itemData.Name;
            },
            TypeRequest: null,
        })
    }

    private OpenModalAgregarTareaAgenda() {
        this.CARDCOLLAD_OpenModal_ActionFormToAGridData({
            Title: _L("grupopanelagenda.ttl_agendatask_add"),
            Action: Entidad.CAccionPermiso.Agregar,
            IdsEscuelas: [this.GetIdEscuela()],
            Width: 350,
            GetForm: () => AgendaTaskActionForm(null, Entidad.CAccionPermiso.Agregar, this.GetCurrentGroup().IdGrupo),
            OnAccept: async (form) => {
                let dataForm = form._Data;
                const { StrStart } = dataForm;
                let dateStart = UIUtilTime._GetLocalDateFromInputDateString(StrStart);
                let dateEnd = new Date(dateStart);
                dateEnd.setDate(dateEnd.getDate() + 1);
                dateEnd.setMilliseconds(dateEnd.getMilliseconds() - 1);

                let res = await _SvAgregarAgendaTarea({ ...dataForm, StrStart: dateStart.toISOString(), StrEnd: dateEnd.toISOString() }, this.GetIdEscuela())
                return res;
            },
            OnEndReloadService: async (res) => {
                if (res.Resultado > 0) {
                    this.UI_UpdateCardData();
                }
            },
            TypeRequest: null,
        })
    }

    private async ConfirmActionGoToCalendars(event: IAgendaEvent, action: Entidad.CAccionPermiso) {
        const hasActionPermission = UIUtilPermission._HasAccionPermission(action, Entidad.CModulo.Calendarios, this.GetIdEscuela());

        let lblTitle = '';

        switch (action) {
            case Entidad.CAccionPermiso.Agregar:
                lblTitle = _L("c_actions.agregar");
                break;
            case Entidad.CAccionPermiso.Editar:
                lblTitle = _L("c_actions.editar");
                break;
            case Entidad.CAccionPermiso.Eliminar:
                lblTitle = _L("c_actions.eliminar");
                break;
        }

        if (!hasActionPermission) {
            this.ctrlNotification._Mostrar(_L("grupopanelagenda.msg_calendars_nopermission_action", lblTitle, this.GetCurrentGroup().NombreKinder), "ADVERTENCIA");
            return;
        }

        const confirm = await _ModalConfirmacionBasicoV2({
            Title: lblTitle,
            Width: 300,
            Content: _L("grupopanelagenda.confirm_action_redirecttocalendars"),
        })

        if (confirm) {
            Router._DoHash("escuelas/calendarios");
            Router._ReplaceState("escuelas/calendarios", "", { ...event, mode: action })
        }
    }
}